export const EccnEar99ValidationRegex = /^(\d[A-Z]\d{3}[\da-z.]{0,15}|EAR99)$/;

export const DEFAULT_CUSTOMS_ITEM_DESCRIPTION_MAX_LENGTH = 150;
export const USPS_CUSTOMS_ITEM_DESCRIPTION_MAX_LENGTH = 30;
export const SKU_CODE_MAX_LENGTH = 100;

export const ValidationMessagesMap = {
  description: {
    invalid: {
      USPS: `Description must be ${USPS_CUSTOMS_ITEM_DESCRIPTION_MAX_LENGTH} characters or fewer`,
      default: `Description must be ${USPS_CUSTOMS_ITEM_DESCRIPTION_MAX_LENGTH} characters or fewer`,
    },
    required: 'Please enter the item title',
  },
  eccnEar99: {
    invalid: 'Please enter a valid ECCN/EAR99 code',
  },
  massUnit: {
    required: 'Please select a mass unit',
  },
  originCountry: {
    required: 'Please select a country of origin',
  },
  quantity: {
    invalid: 'Please enter a valid quantity',
    required: 'Please enter the item quantity',
  },
  skuCode: {
    invalid: `This field cannot be longer than ${SKU_CODE_MAX_LENGTH} characters`,
  },
  tariffNumber: {
    invalid: 'This field cannot be longer than 12 characters',
  },
  unitValue: {
    invalid: 'Please enter a valid unit value',
    required: 'Please enter unit value',
  },
  unitWeight: {
    invalid: 'Please enter a valid unit weight',
    required: 'Please enter unit weight',
  },
  valueCurrency: {
    required: 'Please select a currency',
  },
};
